import { useState } from "react";

interface ShareButtonProps {
  title: string;
  text?: string;
}

export default function ShareButton({ title, text }: ShareButtonProps) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2200);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const nativeShare = async () => {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, text: text || title, url: currentUrl });
        setOpen(false);
      } catch {
        /* user cancelled */
      }
    } else {
      showToast("当前浏览器不支持原生分享，已为你复制链接");
      await copyLink();
    }
  };

  const socials = [
    { label: "微信", icon: "ri-wechat-line" },
    { label: "微博", icon: "ri-weibo-line" },
    { label: "QQ", icon: "ri-qq-line" },
  ];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-forward-line text-base" />
        分享
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-64 z-50 bg-background-50 border border-background-200 rounded-lg p-4 animate-fade-up">
            <p className="text-sm font-semibold text-foreground-950 mb-3">分享到</p>
            <div className="grid grid-cols-3 gap-2 mb-3">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  onClick={() => {
                    showToast(`${s.label}分享仅作演示`);
                  }}
                  className="flex flex-col items-center gap-1 py-2 rounded-md bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-xl text-primary-500`} />
                  <span className="text-xs text-foreground-700">{s.label}</span>
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={copyLink}
              className="w-full inline-flex items-center justify-center gap-1.5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-link" />
              复制链接
            </button>
            <button
              type="button"
              onClick={nativeShare}
              className="mt-2 w-full inline-flex items-center justify-center gap-1.5 py-2 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer"
            >
              <i className="ri-share-line" />
              系统分享
            </button>
          </div>
        </>
      )}

      {toast && (
        <div className="fixed left-1/2 bottom-10 -translate-x-1/2 z-[60] px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm animate-fade-up">
          {toast}
        </div>
      )}
    </div>
  );
}